// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui-menu-tooltip[data-v-2c552930] {\n\tz-index: 8;\n}\n", ""]);
// Exports
module.exports = exports;
